<template>
  <div class="">
    <template v-for="(currentDetail, index, i) in model">
      <div 
      :ref="`raw_fabric_${currentDetail.id}`"
      :id="`raw_fabric_${currentDetail.id}`"
           :class="{'mt-5': +i !== 0}"
      >
      <div class="d-flex navy-blue-border-bottom-1px px-2 py-2">
        <span class="h6 text-sm mr-2">{{$t('general.created_at')}}:</span><span class="text-sm">{{currentDetail.created_at?moment(currentDetail.created_at).format('DD.MM.YYYY hh:mm:ss'):moment().format('DD.MM.YYYY hh:mm:ss')}}</span>
        
        <span class="mx-1 h25"> / </span>
        <span class="h6 text-sm mr-2">
          {{$t('general.updated_date')}}:</span><span class="text-sm"> {{currentDetail.updated_at?moment(currentDetail.updated_at).format('DD.MM.YYYY hh:mm:ss'):moment().format('DD.MM.YYYY hh:mm:ss')}}</span>
        
     </div>

        <div style="overflow-x:auto;" class="mb-5">
          <div class="d-flex">
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.supplier_company') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.fabric_type') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.knitting_type') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.flow_date') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.end_date') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.dispatch_location') }}
          </div>
        </div>
        <div class="d-flex">
          <div class="col-6 top-1-items py-2 text-center">
            <custom-multi-select
                :options="supplierCompanyOptions"
                :title="null"
                :item-per-row="1"
                :disabled="currentDetail.lockable_company &&  isUserGranted('Order', ['updateInstructionSupplierCompany'],false,true)"
                :model.sync="currentDetail.supplier_company_id"
                :name="`order_fabric_raw_fabric_supplier_company_${index}`"
                :max="1"
                :not-list="true"
                :required="false"
                size="sm"
                :has-bottom-margin="false"
            ></custom-multi-select>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <input type="text"
                   v-model="currentDetail.fabric_type"
                   class="form-control form-control-sm"
                   :placeholder="$t('order.please_enter_fabric_type')"
                   :name="`order_fabric_raw_fabric_fabric_yarn_type_${index}`"
                   :class="{'is-invalid': !currentDetail.fabric_type}"
                   style="background-color: #f3f6f9; border-color: #78cdea;">
          </div>
          <div
              class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <input type="text"
                     v-model="currentDetail.knitting_type"
                     class="form-control form-control-sm"
                     :placeholder="$t('order.please_enter_knitting_type')"
                     :name="`order_fabric_raw_fabric_knitting_type_${index}`"
                     :class="{'is-invalid': !currentDetail.knitting_type}"
                     id="">
            </div>
          </div>
          <div
              class="col-6 top-1-items py-2 text-center">
            <div>
              <date-picker-input
                  :title="null"
                  :required="false"
                  :name="`order_fabric_raw_fabric_flow_date_${index}`"
                  :model.sync="currentDetail.flow_date"
                  :input-classes="'w-85px'"
                  :has-bottom-margin="false"
              ></date-picker-input>
            </div>
          </div>
          <div
              class="col-6 top-1-items py-2 text-center">
            <div>
              <date-picker-input
                  :title="null"
                  :required="false"
                  :name="`order_fabric_raw_fabric_end_date_${index}`"
                  :model.sync="currentDetail.end_date"
                  :input-classes="'w-85px'"
                  :has-bottom-margin="false"
              ></date-picker-input>
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <custom-multi-select
                :options="dispatchLocationOptions"
                :title="null"
                :item-per-row="1"
                :max="1"
                :model.sync="currentDetail.dispatch_location_ids"
                :name="`order_fabric_raw_fabric_fabric_yarn_type_${index}`"
                :required="false"
                size="sm"
                :has-bottom-margin="false"
                :is-right="true"
            ></custom-multi-select>
          </div>
        </div>
        </div>

        <div style="overflow-x:auto" class="mb-5">
          <div class="d-flex">
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.color') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.fein_pus') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.color') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.quantity') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.unit') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.tolerance_quantity') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.total_quantity') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.incoming_quantity') }}
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            {{ $t('order.remaining_quantity') }}
          </div>
        </div>

        <div class="d-flex ">
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <custom-multi-select
                  :item-per-row="1"
                  :max="1"
                  :model.sync="currentDetail.order_size_and_color_id"
                  :not-list="true"
                  :options="orderSizeAndColorOptions"
                  :placeholder="$t('general.please_select_option')"
                  :required="false"
                  :title="null"
                  name="orderSizeAndColorOptions"
                  width="300px"
                  @onSelect="orderSizeAndColorSave($event, index)"
              ></custom-multi-select>
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <input
                  type="text"
                  :name="`order_fabric_raw_fabric_fabric_color_${index}`"
                  :title="null"
                  :required="false"
                  v-model="currentDetail.fein_pus"
                  :placeholder="$t('order.please_enter_color')"
                  class="form-control form-control-sm"
                  :class="{'is-invalid': !currentDetail.fein_pus}"
              >
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <input
                  type="text"
                  :name="`order_fabric_raw_fabric_fabric_quantity_${index}`"
                  :title="null"
                  :required="false"
                  v-model="currentDetail.color"
                  :placeholder="$t('order.please_enter_quantity')"
                  class="form-control form-control-sm"
                  :class="{'is-invalid': !currentDetail.color}"
              >
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <input
                  type="number"
                  :name="`order_fabric_raw_fabric_fabric_tolerance_quantity_${index}`"
                  :title="null"
                  :required="false"
                  v-model="currentDetail.amount"
                  :placeholder="$t('order.please_enter_tolerance_amount')"
                  class="form-control form-control-sm"
                  step="1"
                  :class="{'is-invalid': !+currentDetail.amount}"
              >
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
            <custom-multi-select
                :has-bottom-margin="false"
                :item-per-row="2"
                :max="1"
                :model.sync="currentDetail.amount_unit_id"
                :name="`amount_unit_id_${index}`"
                :not-list="true"
                :options="amountUnitOptions"
                :required="false"
                :title="null"
                size="sm"
            ></custom-multi-select>
           </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center">
            <div class="px-2">
              <input
                  type="number"
                  :name="`order_fabric_raw_fabric_fabric_tolerance_quantity_${index}`"
                  :title="null"
                  :required="false"
                  v-model="currentDetail.tolerance_amount"
                  :placeholder="$t('order.please_enter_tolerance_amount')"
                  class="form-control form-control-sm"
                  :max="maxTolerance"
                  :step="1"
                  style="background-color: #f3f6f9; border-color: #78cdea;"
                  :class="{'is-invalid': !+currentDetail.tolerance_amount || +currentDetail.tolerance_amount > maxTolerance || +currentDetail.tolerance_amount < 1}"
              >
            </div>
          </div>
          <div class="col-6 top-1-items py-2 text-center d-flex justify-content-center items-center">
            {{ totalAmount(index) | amountFormat}}
          </div>
          <div class="col-6 top-1-items py-2 text-center d-flex justify-content-center items-center">{{ currentDetail.incoming_amount | amountFormat }}</div>
          <div class="col-6 top-1-items py-2 text-center d-flex justify-content-center items-center"> {{ currentDetail.remaining_amount | amountFormat  }}</div>
        </div>
        </div>

        <test-method-row
            :test-method-options="productProcesses"
            :selected-test-methods.sync="currentDetail.selectedProductProcesses"
            :product-processes.sync="currentDetail.product_processes"
            :is-required="false"
        ></test-method-row>

        <currency-table-row
            :currency-options="currencyOptions"
            :currency-options-raw="currencyOptionsRaw"
            :currency-rate-options="currencyRateOptions"
            :expiration-type-options="expirationTypeOptions"
            :model="currentDetail"
            :v-a-t-rate-options="VATRateOptions"
        ></currency-table-row>

        <div class="d-flex">
          <div class="d-flex flex-column w-100">
            <span class="font-weight-bolder mx-3 mb-3">{{$t('order.description')}}</span>
             <div class="flex-1 px-2 py-3">
            <textarea-input
                :title="''"
                :name="`order_fabric_raw_fabric_fabric_description_${index}`"
                :model.sync="currentDetail.description"
                :required="false"
                :is-valid="!!currentDetail.description"
                :size="'lg'"
            ></textarea-input>
             </div>
          </div>
        </div>
      </div>
      <span v-if="index > 0 && !currentDetail.id" class="cursor-pointer" @click="deleteNewDetail(index)" v-html="getIconByKey('icons.sample.delete_red',{
                        class: 'w-20px h-20px d-inline-block mr-3 '
                      })"></span>

      <span v-if="isValidToSubmit && index == modelProxy.length - 1"
            class="cursor-pointer"
            @click="addNewDetail"
            v-html="getIconByKey('icons.waybill.waybill_entry', {
            class: 'w-50px h50px d-line-block object-fill',
          })"
      ></span>

      <bottom-buttons
          :emails="[]"
          :is-editing.sync="currentDetail.is_editing"
          :is-valid-to-submit="isValidToSubmit(index)"
          :model="currentDetail"
          :order-id="orderId"
          name="raw-fabric-request"
          :send-mail-url="sendMailUrl(index)"
          @addNewDetail="addNewDetail"
          @onCancelInstruction="onCancelInstruction(currentDetail.id, index)"
          @submit="submitOrderFabricRawFabric (index)"
          style="display:flex; flex-wrap: wrap; font-size: 9px; width: 100%; border:1px solid #78cdea; padding-bottom: 12px; border-radius: 12px;"
      ></bottom-buttons>
    </template>
  </div>
</template>

<script>
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import DatePickerInput from "@/assets/components/inputs/DatePickerInput";
import TextInput from "@/assets/components/inputs/TextInput";
import NumberInput from "@/assets/components/inputs/NumberInput";
import TestMethodRow from "@/view/pages/order/layout/TestMethodRow";
import _ from "lodash";
import CurrencyTableRow from "@/view/pages/order/layout/CurrencyTableRow";
import TextareaInput from "@/assets/components/inputs/TextareaInput";
import BottomButtons from "@/view/pages/order/layout/BottomButtons";
import {CREATE_ITEM, DELETE_ITEM_BY_ID, UPDATE_ITEM_BY_ID} from "@/core/services/store/REST.module";
import moment from "moment";
import {LARAVEL_DATE_TIME_FORMAT} from "@/core/config/constant";

export default {
  name: "OrderFabricRawFabricTypeTable",
  components: {
    BottomButtons,
    TextareaInput,
    CurrencyTableRow, TestMethodRow, NumberInput, TextInput, DatePickerInput, CustomMultiSelect
  },
  props: {
    model: {
      required: true,
    },
    totalInstructions:{
      required:false,
    },
    maxPrice:{
      required: false,
    },
    maxPriceUnit:{
      required:false,
    },

    amountUnitOptions: {
      required: true
    },
    defaultModel: {
      required: true,
    },
    orderId: {
      required: true,
      default: null,
    },
    order: {
      required: true,
      default: null,
    },
    maxTolerance: {
      required: true,
      default: 0,
    },
    currentInstructionTypeId: {
      required: true,
    },
    supplierCompanyOptions: {
      required: true,
    },
    fabricTypeOptions: {
      required: true,
    },
    dispatchLocationOptions: {
      required: true,
    },
    currencyOptions: {
      required: true,
    },
    expirationTypeOptions: {
      required: true,
    },
    VATRateOptions: {
      required: true,
    },
    currencyRateOptions: {
      required: true,
    },
    currencyOptionsRaw: {
      required: true
    },
    didChangeProcessingType: {
      required: true,
      type: Boolean,
    },
    productProcesses: {
      required: true,
    },
    orderFabricOptions: {
      required: true,
    },
    fabricProcessingType: {
      required: true,
    },
    orderFabricId: {
      required: true,
    },
    netIncomingFabricAmount: {
      required: true,
    },
    orderSizeAndColorOptions: {
      required: true,
    }
  },
  data() {
    return {
      is_submitting: false
    }
  },
  methods: {
    maxPriceCheck(index){
      console.log(index);
      let modelTotal = 0;
      let fabricCurrencyUnit=this.maxPriceUnit;
      let allCurrencyRate=this.currencyRateOptions;
      let orderFabric = _.find(this.order.order_fabrics,{'id':+this.orderFabricId});
      let modelItem = this.model[index];

      let modelExchanegeRate=1;
      let modelCurrencyUnit=null;
      if(modelItem.currency_unit){
        modelCurrencyUnit=modelItem.currency_unit.code;
      }else{
        modelCurrencyUnit=this.currencyOptions[modelItem.currency_unit_id];
      }
      
      let findCurrencyForFabric=_.find(allCurrencyRate,{"code":fabricCurrencyUnit});
      let findCurrencyForModel=_.find(allCurrencyRate,{"code":modelCurrencyUnit});

      if((modelCurrencyUnit=="TL"||modelCurrencyUnit=="TRY")&&(fabricCurrencyUnit=="TRY"||fabricCurrencyUnit=="TL")){
        modelExchanegeRate=findCurrencyForFabric.rate;
        modelTotal+=Number(modelItem.total_price)/modelExchanegeRate;
      }else if(fabricCurrencyUnit==modelCurrencyUnit){
        modelTotal+=Number(modelItem.total_price);
      }else{

        modelExchanegeRate=findCurrencyForModel.rate/orderFabric.exchange_rate;
        modelTotal+=Number(modelItem.total_price)*modelExchanegeRate;
      }
      let modelPlusTotalAllInstructions=this.totalInstructions;
      if(modelPlusTotalAllInstructions>this.maxPrice){
        return false;
      }
      return true;
    },

    orderSizeAndColorSave(selectedValue, index) {
      let model = this.modelProxy[index];
      let value = Number(selectedValue);
      let newItem = this.order.order_fabric_requirements.find(x => parseInt(x.order_fabric_id) === parseInt(model.order_fabric_id) && parseInt(x.order_size_and_color_id) === parseInt(model.order_size_and_color_id));
      model.amount = newItem.amount;
      if (this.netIncomingFabricAmount) {
        model.amount -= Number(this.netIncomingFabricAmount.find(item => +item.id === value).amount);
      }
    },
    onCancelInstruction(itemId, index) {
      const self = this;
      this.$store.dispatch(DELETE_ITEM_BY_ID, {
        url: `api/order/${this.orderId}/raw-fabric-request/${itemId}`
      }).then(function (response) {
        if (response.status) {
          self.sweetAlertSuccess(self.$t('general.successfully_deleted'));
          self.modelProxy.splice(index, 1);
          if (!self.modelProxy.length) {
            self.modelProxy = [self.defaultModel];
          }
        } else {
          self.sweetAlertError(self.$t('general.internal_error'));
        }
      });
    },
    deleteNewDetail(index) {
      this.modelProxy.splice(index, 1);
    },
    addNewDetail() {
      let copy = _.cloneDeepWith(this.defaultModel);
      copy.is_submitted = false;
      copy.is_editing = false;
      copy.amount = 0;
      copy.id = null;
      this.$emit("getIncomingFabricAmount");
      this.modelProxy.push(copy);
    },
    fixedData(index) {
      let items = [];
      let self = this;
      let item = this.modelProxy[index];

      item.dispatch_locations = item.dispatch_location_ids.map(location => {
        return {
          id: location,
        }
      });

      item.order_fabric_id = self.orderFabricId;
      item.flow_date = moment(item.flow_date).format(LARAVEL_DATE_TIME_FORMAT);
      item.end_date = moment(item.end_date).format(LARAVEL_DATE_TIME_FORMAT);

      items.push(item);

      return items;
    },
    submitOrderFabricRawFabric(index) {
      let maxControl = this.maxPriceCheck(index);
      if(maxControl==false){
        this.sweetAlertError(this.$t('order.instruction_max_error'));
        return false;
      }

      if (this.is_submitting) return false;
      this.is_submitting = true;
      this.sweetAlertLoading();
      this.updateOrCreate(index);
    },
    updateOrCreate(index) {
      const self = this;
      self.$store.dispatch(CREATE_ITEM, {
        url: `api/order/${self.orderId}/raw-fabric-request`,
        contents: {
          order_raw_fabric_requests: self.fixedData(index),
        }
      }).then(response => {
        if (response.status) {
          let detail = self.modelProxy[index];
          let is_editing = !!detail.id;
          let responseData = response.data[0];
          detail.id = responseData.id
          detail.is_submitted = true;
          detail.is_editing = false;
          detail.pdf_link = responseData.pdf_link;
          detail.order_fabric_excel_link = responseData.order_fabric_excel_link
          detail.remaining_amount = responseData.remaining_amount

          self.modelProxy[index] = detail;

          self.sweetAlertSuccess(self.$t(is_editing ? 'general.successfully_updated' : 'general.successfully_created'));
        } else {
          let result = response.data.response;
          if (result.hasOwnProperty('data') && result.data.hasOwnProperty('message')) {
            self.sweetAlertError(result.data.message);
          } else {
            self.sweetAlertError(result.data);
          }
        }
        self.sweetAlertClose();
        self.is_submitting = false;
      });
    }
  },
  computed: {
    moment: () => moment,
    modelProxy: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      }
    },
    totalAmount() {
      return function (index) {
        this.modelProxy[index].total_amount = this.modelProxy[index].amount * (1 + (+this.modelProxy[index].tolerance_amount / 100))
        return (+this.modelProxy[index].total_amount);
      }
    },
    isValidToSubmit() {
      try {
        let returnData = null;

        returnData = function (key) {
          const current = this.modelProxy[key];
          if (!+current.supplier_company_id) return false;
          if (!current.fabric_type) return false;
          if (current.knitting_type === '' || current.knitting_type === null) return false;
          if (!current.dispatch_location_ids.length) return false;
          if (current.fein_pus === '' || current.fein_pus === null) return false;
          if (current.color === '' || current.color === null) return false;
          if (!+current.currency_unit_id) return false;
          if (!+current.order_size_and_color_id) return false;
          if (!+current.expiry_id) return false;
          if (!+current.unit_price) return false;
          if (!+current.vat_rate_id) return false;
          if (current.description === null || current.description === '') return false;
          return true;
        }

        return returnData;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    sendMailUrl() {
      try {
        let returnData = null;
        returnData = function (key) {
          const itemId = this.modelProxy[key].id;
          return `api/order/${this.orderId}/raw-fabric-request/${itemId}/share`
        }
        return returnData;
      } catch (e) {
        console.error(e);
        return false;
      }
    }
  },
  mounted() {
    this.modelProxy.forEach(model => {
      let orderFabricId = this.orderFabricId;

      model.fabric_supply_type_id = this.fabricProcessingType;
      model.tolerance_amount = this.maxTolerance;
      model.order_fabric_id = orderFabricId
    })
    if(this.$route.query.qr_type=="raw-fabric"){
        setTimeout(() => {
            let instructionsId = this.$route.query.data.id
            let element = this.$refs["raw_fabric_"+instructionsId][0]
            if(element){
              element.scrollIntoView({behavior: "smooth"})
            }
          }, 2000);
      }
  },
  watch: {
    modelProxy: {
      handler(newValue, oldValue) {
        if (newValue) {
          newValue.forEach(model => {
            model.fabric_supply_type_id = this.fabricProcessingType;
            model.tolerance_amount = this.maxTolerance;
            model.order_fabric_id = this.orderFabricId;
            let newId = this.orderFabricId;

            if (!model.fabric_type) {
              model.fabric_type = this.orderFabricOptions.filter(x => parseInt(x.id) === parseInt(newId))[0].type;
            }
          })
        }
      },
      deep: true
    },
    orderFabricId(value) {
      let self = this;
      this.modelProxy.forEach(model => {
        model.order_fabric_id = value;
        let newItem = this.order.order_fabric_requirements.find(x => parseInt(x.order_fabric_id) === parseInt(model.order_fabric_id) && parseInt(x.order_size_and_color_id) === parseInt(model.order_size_and_color_id));
        if (newItem) {
          model.amount = newItem.amount;
          if (self.netIncomingFabricAmount) {
            model.amount -= Number(self.netIncomingFabricAmount.find(item => +item.id === +model.order_size_and_color_id).amount);
          }
        }
      })
    },
    maxTolerance(value) {
      this.modelProxy.forEach(model => {
        model.tolerance_amount = value;
      })
    },
    netIncomingFabricAmount(value) {
      this.modelProxy.forEach(model => {
        if (!model.amount) {
          let newItem = this.order.order_fabric_requirements.find(x => parseInt(x.order_fabric_id) === parseInt(model.order_fabric_id) && parseInt(x.order_size_and_color_id) ===  parseInt(model.order_size_and_color_id));

          if (newItem)
            model.amount = newItem.amount - value;
        }
      })
    }
  }
}
</script>

<style>

</style>
